/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserCreateResponse {
    getFixupPrototypeFunction() { return UserCreateResponse.fixupPrototype; }

    static newInstance(model: Partial<UserCreateResponse>): UserCreateResponse {
        let obj = Object.assign(new UserCreateResponse(), model);
        UserCreateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserCreateResponse>): UserCreateResponse {
        if (!model) return null;
        return UserCreateResponse.newInstance(<UserCreateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserCreateResponse) {
        if (!obj) return;

        models.UserCreateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserCreateResponse): boolean {
        Object.setPrototypeOf(obj, UserCreateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the newly created User
     */
    user_id: string;

}
